import React from 'react';
import axios from 'axios';
import './Upload.css';

class Uploader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      uploaded: false,
      error: null,
    };
  }

  onFileUpload = async (e) => {
    const formData = new FormData();
    formData.append('file', e.target.files[0]);

    this.setState({ uploaded: false, error: null });

    try {
      await axios({
        method: 'post',
        url: this.props.uploadEndpoint,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      this.setState({ uploaded: true });
    } catch (err) {
      this.setState({ error: err.response?.data?.error || 'Upload failed. Please try again.' });
    }
  }

  render() {
    return (
      <div className="upload-container">
      { this.state.uploaded &&
          <div className="upload-done">Uploaded!</div>
        }
      { this.state.error &&
          <div className="upload-error">{this.state.error}</div>
        }
        <div className="upload-content">
          <div className="custom-file">
            <input
              type="file"
              className="custom-file-input"
              id="customFile"
              multiple={false}
              accept={`.${this.props.format}`}
              onChange={this.onFileUpload}
            />
            <label className="custom-file-label">{this.props.placeholder}</label>
          </div>
        </div>
      </div>
    );
  }
}

export default Uploader;
